export const CompanyMonitoringAlertCategoryEnum = {
  financial_changes: 'financial_changes',
  legal_and_compliance: 'legal_and_compliance',
  company_status: 'company_status',
  operational_changes: 'operational_changes',
  debt_and_collection: 'debt_and_collection',
  shareholder_changes: 'shareholder_changes',
  other: 'other',
} as const;
export type CompanyMonitoringAlertCategoryEnum =
  (typeof CompanyMonitoringAlertCategoryEnum)[keyof typeof CompanyMonitoringAlertCategoryEnum];
